import { render, staticRenderFns } from "./SurveyFormTextarea.vue?vue&type=template&id=01471d37&scoped=true&"
import script from "./SurveyFormTextarea.vue?vue&type=script&lang=js&"
export * from "./SurveyFormTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01471d37",
  null
  
)

export default component.exports